import SectionHeading from './SectionHeading';
import { overviewFeatures } from '@/mocks/home';

export default function Overview() {
  return (
    <section id="overview" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Platform Overview"
          title="这个平台能做什么"
          desc="在解决具体问题之前，先了解平台的基本能力。下面的分区说明覆盖了日常使用中最常接触到的几个方面，也会帮你判断遇到的情况属于哪一类。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {overviewFeatures.map((f) => (
            <article
              key={f.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${f.accentBg} ${f.accentText}`}>
                <i className={`${f.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}